'use strict';

DoohApps
    .factory('UserRoleData', ['restApi', function (restApi) {
    var controllerName = 'Company/';

    return {
        getUserRoles: function (successCallback,filter) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetRoles',filter);
        },
        saveRole: function (successCallback, role) {
            restApi.PostApiMethod(successCallback, controllerName + 'PostRole', role);
        },
        deleteRole: function (successCallback, id) {
            restApi.DeleteApiMethod(successCallback, controllerName + 'DeleteRole?Id=' + id);
        },
        getAllRoles: function (successCallback) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetAllRoles');
        },
        getUserRoleUsers: function (successCallback, id) {
            restApi.GetApiMethod(successCallback, controllerName + 'GetUserRoleUsers?roleId=' + id);
        },
    }
}])
